<template lang="pug">
  ul.accordion
    slot
</template>

<script>
export default {
  name: 'Accordion',
  props: {
    initActive: {
      type: Number,
      default: null
    }
  },
  data: (vm) => ({
    Accordion: {
      count: 0,
      active: vm.initActive
    }
  }),
  provide () {
    return { Accordion: this.Accordion }
  }
}
</script>
